import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComparisonType, Milliseconds } from '@iotv/iotv-v3-types';
import { InputAdornment, Stack, Switch, TextField, Toolbar, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
export const TypeBySeen = (props) => {
    const { updateParams: setParamsInParent, lastQuery, keyPress, lastQueryParamsRef, type, attKey, index, children, selected } = props;
    const [params, setParams] = useState(lastQuery ?? { type, attKey, value: '4' });
    const [active, setActive] = useState(true);
    const handleParamChange = (e) => {
        let value = e.target.value;
        if (value === '') {
            value = '';
        }
        const stringRegex = /[a-zA-Z]/;
        const hasLetter = stringRegex.test(value);
        if (hasLetter) {
            return;
        }
        const regex = /\./g;
        const matches = value.match(regex);
        const dotCount = matches ? matches.length : 0;
        const params = { type, attKey, value };
        if (dotCount < 2) {
            // lastQueryParamsRef.current = params;
            setParams(params);
        }
    };
    useEffect(() => {
        const val = params?.value;
        if (val !== undefined && selected) {
            const hours = typeof val === 'number' ? val : parseFloat(val);
            let currentTime = Date.now();
            currentTime -= hours * Milliseconds.HOUR;
            if (isNaN(currentTime)) {
                setParamsInParent(undefined, index);
            }
            else {
                setParamsInParent([
                    {
                        key: attKey,
                        value: currentTime,
                        predicate: active ? ComparisonType.GREATER_EQUAL : ComparisonType.LESS_EQUAL,
                    },
                ], index); //LESS_EQUAL
            }
        }
        else {
            setParamsInParent(undefined, index);
        }
    }, [params, selected, active]);
    const handleSwitch = () => {
        setActive(!active);
    };
    return (_jsxs(Toolbar, { children: [children, _jsxs("div", { style: { paddingTop: '10px', paddingBottom: '10px' }, children: [_jsx(Stack, { direction: "row", spacing: 1, sx: { justifyContent: 'center', alignItems: 'center' }, children: _jsx(TextField, { value: params?.value ?? '?',
                            size: 'small',
                            InputProps: {
                                startAdornment: _jsx(InputAdornment, { position: "start", children: active ? `Within` : 'Not in' }),
                                endAdornment: _jsx(InputAdornment, { position: "end", children: `Hour(s)` }),
                            },
                            onChange: handleParamChange,
                            onKeyDown: keyPress }) }), _jsxs(Stack, { direction: "row", spacing: 1, sx: { alignItems: 'center' }, children: [_jsx(Typography, { children: "Not in" }), _jsx(Switch, { size: "small", checked: active, onChange: handleSwitch }), _jsx(Typography, { children: "Within" })] })] })] }));
};
